import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class WorkTableProvider {
  constructor(public http: HttpClient) {
  }
}



// WEBPACK FOOTER //
// ./src/providers/work-table/work-table.ts